import { Button } from "@/components/design-system/button";
import Modal from "@/components/design-system/Modal";
import { bindLabelTextInputHandlers } from "@/utils/formTextField";

interface LevelValueEditModalProps {
  isOpen: boolean;
  value: string;
  onChange: (value: string) => void;
  onClose: () => void;
  onSave: () => void;
  saving?: boolean;
}

export default function LevelValueEditModal({
  isOpen,
  value,
  onChange,
  onClose,
  onSave,
  saving = false,
}: LevelValueEditModalProps) {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Edit value"
      width="520px"
      contentClassName="p-0"
    >
      <div className="p-6">
        <label className="text-[14px] font-medium text-[#1F1F1F] mb-2 block">
          Value name
        </label>
        <input
          className="w-full h-[48px] rounded-[12px] border border-[#E5E7EB] px-4 text-[14px]"
          placeholder="Enter value"
          {...bindLabelTextInputHandlers(value, onChange)}
        />
      </div>
      <div className="flex justify-end border-t border-gray-200 p-4 gap-4">
        <Button
          type="button"
          variant="light"
          size="md"
          className="w-[120px] h-[48px] border border-[#5C88C5]"
          onClick={onClose}
        >
          Cancel
        </Button>
        <Button
          type="button"
          variant="primary"
          size="md"
          className="w-[120px] h-[48px] bg-[#5C88C5] text-white"
          onClick={onSave}
          disabled={saving}
        >
          {saving ? "Saving…" : "Save"}
        </Button>
      </div>
    </Modal>
  );
}
